export type ValidationIssue = {
  label: string;
  isValid: boolean;
};

const FALLBACK_VALIDATION_MESSAGE = "Please fill out all the required fields.";

export const formatValidationIssues = (
  issues: readonly ValidationIssue[]
): string => {
  const invalidLabels = Array.from(
    new Set(issues.filter(({ isValid }) => !isValid).map(({ label }) => label))
  );

  if (invalidLabels.length === 0) return FALLBACK_VALIDATION_MESSAGE;

  return `Please complete or correct the following fields: ${invalidLabels.join(
    ", "
  )}.`;
};
